import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import { DropTarget, DragSource } from 'react-dnd'
import ItemTypes from '~/utils/TemplateEditor/dragDropItemTypes'
import { findDOMNode } from 'react-dom'
import axios from '~/data/http/axios'
import { connect } from 'react-redux'
import SaveBlockDrawer from './saveBlockDrawer'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import i18n from '~/i18n'

import HolderOptions from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/holderOptions.jsx'
import tableRows from './tableRows'
import DragHolder from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/dragHolder.jsx'
import {
    NESTED_HOVER_EVENT,
    NESTED_UNHOVER_EVENT,
    notifyAncestorsNestedHover,
    notifyAncestorsNestedUnhover
} from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/nestedHover'
import { claimActiveHover, releaseActiveHover } from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/activeHover'
import { setActiveDragTuuid, isActiveDragTuuid } from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/activeDrag'
import { computeHolderChrome, isHolderNested } from '~/Common-Objects/TemplateEditor/DragDropStage/Shared/holderChrome'
import { cn } from '~/utils/cn'
import TemplateEditorUtils from '~/Common-Objects/TemplateEditor/Utils'

const dragSource = {
    beginDrag(props, monitor) {
        setActiveDragTuuid(props.elementData && props.elementData.tuuid)
        return { path: props.path }
    },
    endDrag() {
        setActiveDragTuuid(null)
    }
}

const dropSource = {
    drop() {
        return {}
    },
    hover(props, monitor, component) {
        const currentElementType = monitor.getItemType()

        if (currentElementType === 'newHolder' && monitor.getItem().isNew === 0) {
            const currentElementPath = monitor.getItem().path
            const currentElementContent = monitor.getItem().content
            const hoveredElementPath = props.path

            if (!currentElementContent.tuuid) {
                currentElementContent.tuuid = DragDropFunctions.createGUID()
            }
            var newIndex =
                Number(
                    hoveredElementPath.substring(hoveredElementPath.lastIndexOf('[')).replace('[', '').replace(']', '')
                ) + 1
            var newPath =
                hoveredElementPath.substring(0, hoveredElementPath.lastIndexOf('.')) + '.elements[' + newIndex + ']'

            monitor.getItem().path = newPath
            monitor.getItem().isNew = 1
            props.insertElement(hoveredElementPath, currentElementContent, false)
            return
        }
        if (
            currentElementType === 'canvasHolder' ||
            (currentElementType === 'newHolder' && monitor.getItem().isNew === 1)
        ) {
            const currentElementPath = monitor.getItem().path
            const hoveredElementPath = props.path

            if (currentElementPath === hoveredElementPath) {
                return
            }

            const hoverBoundingRect = findDOMNode(component).getBoundingClientRect()
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            const clientOffset = monitor.getClientOffset()
            const hoverClientY = clientOffset.y - hoverBoundingRect.top

            const direction = DragDropFunctions.movingUpDown(currentElementPath, hoveredElementPath)

            // Dragging downwards
            if (direction == 1 && hoverClientY < hoverMiddleY) {
                return
            }

            // // Dragging upwards
            if (direction == -1 && hoverClientY > hoverMiddleY) {
                return
            }

            if (props.moveElement(currentElementPath, hoveredElementPath, false) !== false) {
                monitor.getItem().path = hoveredElementPath
            }
        }
    }
}

@DropTarget([ItemTypes.CANVASHOLDER, ItemTypes.NEWHOLDER, ItemTypes.CANVASITEM], dropSource, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isAnyDragActive: !!monitor.getItemType()
}))
@DragSource(ItemTypes.CANVASHOLDER, dragSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview()
}))
//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster }
})
export default class TableCanvasHolder extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mouseOver: false,
            nestedHoverCount: 0,
            isNestedHolder: false,
            isFirstElement: false
        }
        this.clickHolder = this.clickHolder.bind(this)
        this.mouseEnter = this.mouseEnter.bind(this)
        this.mouseLeave = this.mouseLeave.bind(this)
        this.handleNestedHover = this.handleNestedHover.bind(this)
        this.handleNestedUnhover = this.handleNestedUnhover.bind(this)
        this.clearHoverState = this.clearHoverState.bind(this)
        this.saveBlock = this.saveBlock.bind(this)
        this.saveBlockFinal = this.saveBlockFinal.bind(this)
        this.isFirstElement = this.isFirstElement.bind(this)
        this.nestedHoverNotified = false
        this.holderEl = null
    }
    handleNestedHover() {
        this.setState((state) => ({ nestedHoverCount: state.nestedHoverCount + 1 }))
    }

    handleNestedUnhover() {
        this.setState((state) => ({ nestedHoverCount: Math.max(0, state.nestedHoverCount - 1) }))
    }

    clearHoverState() {
        releaseActiveHover(this)
        if (this.nestedHoverNotified) {
            notifyAncestorsNestedUnhover(this.holderEl)
            this.nestedHoverNotified = false
        }
        if (this.state.mouseOver || this.state.nestedHoverCount) {
            this.setState({ mouseOver: false, nestedHoverCount: 0 })
        }
    }

    componentDidMount() {
        this.isFirstElement()
        this.holderEl = findDOMNode(this)
        if (this.holderEl) {
            this.holderEl.addEventListener(NESTED_HOVER_EVENT, this.handleNestedHover)
            this.holderEl.addEventListener(NESTED_UNHOVER_EVENT, this.handleNestedUnhover)
        }
    }
    componentWillUnmount() {
        releaseActiveHover(this)
        if (this.holderEl) {
            this.holderEl.removeEventListener(NESTED_HOVER_EVENT, this.handleNestedHover)
            this.holderEl.removeEventListener(NESTED_UNHOVER_EVENT, this.handleNestedUnhover)
        }
        if (this.nestedHoverNotified) {
            notifyAncestorsNestedUnhover(this.holderEl)
            this.nestedHoverNotified = false
        }
    }
    clickHolder(event) {
        let okToContinue = TemplateEditorUtils.checkMouseUpHasSelection(event, 'tableCanvasHolder')
        if (!okToContinue) {
            return
        }
        event.stopPropagation()
        this.props.clickElement(this.props.path)
    }
    mouseEnter(event) {
        event.stopPropagation()
        if (this.props.isAnyDragActive) return
        claimActiveHover(this, event.currentTarget, this.clearHoverState)
        if (!this.nestedHoverNotified) {
            notifyAncestorsNestedHover(event.currentTarget)
            this.nestedHoverNotified = true
            this.holderEl = event.currentTarget
        }
        this.setState({ mouseOver: true, isNestedHolder: isHolderNested(event.currentTarget) })
    }
    mouseLeave() {
        this.clearHoverState()
    }

    componentDidUpdate(prevProps) {
        const isCurrentlyDragging = this.props.isDragging || this.props.isAnyDragActive
        const wasDragging = prevProps.isDragging || prevProps.isAnyDragActive
        if (isCurrentlyDragging !== wasDragging && this.props.setDragging) {
            this.props.setDragging(isCurrentlyDragging)
        }
        const isThisDrag =
            this.props.isDragging || isActiveDragTuuid(this.props.elementData && this.props.elementData.tuuid)
        if (isCurrentlyDragging && !isThisDrag && (this.state.mouseOver || this.nestedHoverNotified)) {
            this.clearHoverState()
        }
    }

    saveBlock(forUser) {
        var convObj = {
            globalVariables: {},
            elements: [this.props.elementData]
        }

        //convert blocks to reduced content before saving
        var savedContent = DragDropFunctions.convertToSimpleJson(convObj)

        var theOptions = {
            type: 'saveBlock',
            title: 'Unnamed Block',
            content: savedContent,
            elementId: 0
        }

        var saveProps = {}
        saveProps.name = 'New Block'
        saveProps.options = theOptions
        saveProps.componentType = 2
        if (forUser) {
            saveProps.componentType = 100
            saveProps.published = true
            saveProps.accountMasterId = this.props.accountMaster.id
            var drawerContent = <SaveBlockDrawer saveBlockFinal={this.saveBlockFinal} saveProps={saveProps} />
            this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', drawerContent, true, '500px'))
            return
        }

        this.saveBlockFinal(saveProps, false)
    }

    saveBlockFinal(saveProps, isUser) {
        var self = this
        if (isUser) {
            this.props.dispatch(siteMaster.alterSiteDrawer(false, false, 'right', undefined, false))
        }
        axios.post('/templateComponent', saveProps).then(function (res) {
            self.props.updateBlocks()
        })
    }

    isFirstElement() {
        try {
            let pathJson = this.props.path.split('.')
            let foundNotFirst = false
            for (let i = 1; i < pathJson.length; i++) {
                if (pathJson[i] !== 'elements[0]') {
                    foundNotFirst = true
                    break
                }
            }
            if (!foundNotFirst) {
                this.setState({ isFirstElement: true })
            } else {
                this.setState({ isFirstElement: false })
            }
        } catch (err) {
            console.log(err)
        }
    }

    render() {
        const { canDrop, isOver, connectDropTarget, connectDragSource, isDragging, moveElement, connectDragPreview } =
            this.props

        var activeDrag = isActiveDragTuuid(this.props.elementData && this.props.elementData.tuuid)
        var { isSelected, showChrome, showControls, showOutline, showDragBar } = computeHolderChrome({
            mouseOver: this.state.mouseOver,
            nestedHoverCount: this.state.nestedHoverCount,
            isNestedHolder: this.state.isNestedHolder,
            path: this.props.path,
            selectedPath: this.props.selectedElement.path,
            isDragging,
            isAnyDragActive: this.props.isAnyDragActive,
            activeDrag
        })
        var isSelectedClass = cn(
            isSelected && 'dndEditorv2-elementHolder--selected',
            showOutline && 'dndEditorv2-elementHolder--hovered',
            showChrome && 'dndEditorv2-elementHolder--chrome',
            this.props.showGuideLines && 'dndEditorv2-showGuideLines'
        )

        //figure out if we are the last element holder
        var hasOtherCanvasasData = JSON.stringify(this.props.elementsData)
        var hasOtherCanvasas = 0
        var oCfoundAtPosition = 0
        var oCcount = 0
        while (oCfoundAtPosition != -1 && hasOtherCanvasas < 2) {
            oCfoundAtPosition = hasOtherCanvasasData.indexOf('canvasHolder', oCfoundAtPosition)
            if (oCfoundAtPosition != -1) {
                oCcount++
                oCfoundAtPosition++
            }
        }
        hasOtherCanvasas = oCcount

        var eleProps
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                'table',
                this.props.localVariables
            )
        }

        if (
            this.props.elementData?.ComponentType == 'FormLayout' ||
            this.props.elementData?.ComponentType == 'Layout'
        ) {
            eleProps = {
                ...eleProps,
                'data-canvas-holder': '1'
            }
        }

        let elementHolderStyle = {}
        if (this.state.isFirstElement) {
            elementHolderStyle.marginTop = '20px'
            elementHolderStyle.marginBottom = '20px'
        }
        return connectDropTarget(
            connectDragPreview(
                <div
                    className={cn('dndEditorv2-elementHolder', isSelectedClass)}
                    // style={elementHolderStyle}
                    onClick={this.clickHolder}
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}
                    data-eletuuid={this.props.elementData.tuuid}
                >
                    {/* <div className={'dndEditorv2-elementHolderTools ' + isSelectedClass}></div> */}
                    <div className={'dndEditorv2-elementHolderTools'}>
                        {showControls && (
                            <HolderOptions
                                path={this.props.path}
                                copyElement={this.props.copyElement}
                                deleteElement={this.props.deleteElement}
                                saveBlock={this.saveBlock}
                                canDelete={hasOtherCanvasas > 1}
                                user={this.props.user}
                                moveElementUp={this.props.moveElementUp}
                                moveElementDown={this.props.moveElementDown}
                                elementData={this.props.elementData}
                                elementsData={this.props.elementsData}
                                isLandingPage={this.props.isLandingPage}
                            />
                        )}
                        {showDragBar && (
                            <div
                                className='dndEditorv2-ui-dd-drag-bar'
                                alt={i18n.t('templates:add.drag.block.move')}
                                title={i18n.t('templates:add.drag.block.move')}
                            >
                                <div
                                    className={
                                        'dndEditorv2-ui-dd-tools-dragbar' +
                                        (this.state.isFirstElement ? ' dndEditorv2-ui-dd-tools-dragbar-first' : '')
                                    }
                                >
                                    <DragHolder
                                        element={this.props.elementData}
                                        connectDragSource={connectDragSource}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        {this.state.isFirstElement && showDragBar && <div style={{ height: '20px' }}></div>}
                        <table {...eleProps}>{tableRows(this.props.children)}</table>
                    </div>
                </div>,
                { anchorX: 0.5, anchorY: 0.5 }
            )
        )
    }
}
